import OperatorStore from './OperatorStore';

export default {
  install(store) {
    if (!store.state.base) {
      store.registerModule(['base'], {
        state: {},
      });
    }
    if (!store.state.base.OperatoerOption) {
      store.registerModule(['base', 'OperatoerOption'], OperatorStore);
    }
  },
  uninstall(store) {
    store.unregisterModule(['base', 'OperatoerOption']);
  },
};
